import Speaker from '../components/Speaker.jsx'

/**
 * SPEC screen 1: three big buttons, 2 / 4 / 6.
 *
 * Since D-133 this is not the first screen — the app opens on the roster at age
 * 6 and this is where the band gets changed, reached by holding the top bar's
 * age chip. That makes it a screen a kid can land on by accident, so it has a
 * way out that changes nothing.
 */
export default function AgePicker({ onPick, onBack, current }) {
  return (
    <section className="screen age">
      <h1 className="age__title">How old are you?</h1>
      <Speaker text="How old are you? Tap your number." auto size="lg" />
      <div className="age__grid">
        {['2', '4', '6'].map((n) => (
          <button key={n} className={`age__btn${current === n ? ' is-current' : ''}`} onClick={() => onPick(n)} aria-label={`I am ${n}`}>
            <span className="age__num">{n}</span>
            <span className="age__word">{n === '2' ? 'two' : n === '4' ? 'four' : 'six'}</span>
          </button>
        ))}
      </div>
      {onBack && (
        <button className="btn age__back" onClick={onBack}>
          Back to the animals
        </button>
      )}
    </section>
  )
}
